import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import ErrorBoundary from './components/ErrorBoundary'
import HomePage from './pages/HomePage'
import ProductPage from './pages/ProductPage'
import CartPage from './pages/CartPage'
import CheckoutPage from './pages/CheckoutPage'
import OrderPage from './pages/OrderPage'
import LegalPage from './pages/LegalPage'

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          {/* Pages with own headers */}
          <Route path="/products/:id" element={<ProductPage />} />
          <Route path="/cart" element={<CartPage />} />
          
          {/* Pages with global layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/checkout" element={<Layout><CheckoutPage /></Layout>} />
          <Route path="/orders/:id" element={<Layout><OrderPage /></Layout>} />
          
          {/* Legal Pages */}
          <Route path="/about" element={<Layout><LegalPage title="О продавце" /></Layout>} />
          <Route path="/terms" element={<Layout><LegalPage title="Условия" /></Layout>} />
          <Route path="/privacy" element={<Layout><LegalPage title="Конфиденциальность" /></Layout>} />
          <Route path="/contacts" element={<Layout><LegalPage title="Контакты" /></Layout>} />
        </Routes>
      </Router>
    </ErrorBoundary>
  )
}

export default App
